<template>
  <div>
    <vs-table :data="itemData">
      <template slot="header">
        <!-- <h3 v-if="this.$props.header">{{ header }}</h3> -->
      </template>
      <template slot="thead">
        <vs-th :key="ind" v-for="(col, ind) in columns" sort-key="col.field">{{col.name}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :key="i" v-for="(item, i) in columns" :data="tr[item.field]">{{tr[item.field]}}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: "generic-table",
  props: {
    itemData: {},
    columns: {
        type: Array,
    }
  },
  methods: {},
  data() {
    return { };
  }
};
</script>

<style>
</style>